import i18n from 'i18next';
import getDateString from './getDateString';

export default ({ isPublished, publishedAt, updatedAt }) => {
  if (isPublished === undefined) return '';
  if (!isPublished && !publishedAt) return i18n.t('unpublished');

  return i18n.t(isPublished ? 'published-date' : 'archived-date', {
    date: getDateString(isPublished ? publishedAt : updatedAt),
  });
};
